export function mergeWithPriority(additionals: any[], ...arrays: any[][]) {
  const result: any[] = [];
  const priorityItems: { [description: string]: any } = {};

  // Função auxiliar para padronizar a descrição
  const normalizeDescription = (description: string) => {
    const lowerCaseDescription = description.toLowerCase();
    if (lowerCaseDescription.includes('corporate director') || lowerCaseDescription.includes('corporate directors')) {
      return 'corporate directors';
    }
    if (lowerCaseDescription === 'director' || lowerCaseDescription === 'directors') {
      return 'directors';
    }
    if (lowerCaseDescription === 'shareholder' || lowerCaseDescription === 'shareholders') {
      return 'shareholders';
    }
    return lowerCaseDescription;
  };

  // Adicionar itens adicionais com prioridade
  if (additionals) {
    for (const item of additionals) {
      const normalizedDescription = normalizeDescription(item.description);
      if (priorityItems[normalizedDescription]) {
        priorityItems[normalizedDescription].count += item.count || 0;
        priorityItems[normalizedDescription].value = item.value || priorityItems[normalizedDescription].value;
      } else {
        priorityItems[normalizedDescription] = { ...item, description: normalizedDescription };
      }
    }
  }

  // Mesclar arrays adicionais
  for (const array of arrays) {
    if (Array.isArray(array)) {
      for (const item of array) {
        const normalizedDescription = normalizeDescription(item.description);
        if (priorityItems[normalizedDescription]) {
          priorityItems[normalizedDescription].count += item.count || 0;
          priorityItems[normalizedDescription].value = item.value || priorityItems[normalizedDescription].value;
        } else {
          priorityItems[normalizedDescription] = { ...item, description: normalizedDescription };
        }
      }
    }
  }

  // Adicionar itens ao resultado final
  for (const key in priorityItems) {
    if (Object.prototype.hasOwnProperty.call(priorityItems, key)) {
      result.push(priorityItems[key]);
    }
  }

  return result;
}
